// @flow
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import { FilterList as FilterIcon } from "@material-ui/icons";
import ScheduleFilter from "./ScheduleFilter";
import Popover from "@material-ui/core/Popover";
import {
  useAnalytics,
  useFirestore,
  useFirestoreCollectionData,
} from "reactfire";
import React, { useState } from "react";
import type { TeamFilterTypes } from "../../common/types";

type Props = {
  teamFilter: TeamFilterTypes,
  setTeamFilter: Function,
};

function ScheduleHeaderFilterButton({ teamFilter, setTeamFilter }: Props) {
  const firestore = useFirestore();
  const analytics = useAnalytics();
  const teamsRef = firestore.collection("teams");
  const teams = useFirestoreCollectionData(teamsRef);

  const [showTeamFilter, setShowTeamFilter] = useState(false);

  const updateTeamFilter = (newTeamFilter: [string]) => {
    setTeamFilter(newTeamFilter);
  };

  const closeTeamFilter = () => {
    analytics.logEvent("team_filter_used", {
      location: "ScheduleHeaderFilterButton",
    });
    setShowTeamFilter(false);
  };

  return (
    <Box>
      <IconButton
        color="inherit"
        id="filterButton"
        onClick={() => setShowTeamFilter(true)}
      >
        <FilterIcon />
      </IconButton>
      <ScheduleFilter
        teams={teams}
        open={showTeamFilter}
        onOpen={() => setShowTeamFilter(true)}
        onClose={closeTeamFilter}
        checked={teamFilter}
        setChecked={updateTeamFilter}
      />
      <Popover
        open={false}
        anchorEl={() => document.getElementById("filterButton")}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        The content of the Popover.
      </Popover>
    </Box>
  );
}

export default ScheduleHeaderFilterButton;
